import React from 'react';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import {getSelectedItemText} from '../../QCManager/QCManagerJobsControlButtons/QCManagerJobsControlButtons';

import './QCWorkQueueJobsControlButtons.scss';

export interface QCWorkQueueJobsControlButtonsProps {
    handleMultiItemsNewJiraIssue?: () => void;
    rowsLength: number;
    checkedItems: number[];
    isJiraCreationDisabled: boolean;
}

export const getJiraCreateLink = (handleMultiItemsNewJiraIssue: (() => void) | undefined, isJiraCreationDisabled: boolean) => {
    return isJiraCreationDisabled ? (
        <Tooltip
            placement="right-start"
            title="Selected items must have the same provider and not mrss."
        >
            <div
                className="jira-disabled-link"
            >
                    New Jira issue
            </div>
        </Tooltip>
    ) : (
        <div
            role="button"
            className="control-link control-link_jira-status"
            onClick={handleMultiItemsNewJiraIssue}
        >
            New Jira issue
        </div>
    );
};

const QCWorkQueueJobsControlButtons = (props: QCWorkQueueJobsControlButtonsProps) => {
    const {
        handleMultiItemsNewJiraIssue,
        rowsLength,
        checkedItems,
        isJiraCreationDisabled,
    } = props;

    const checkedItemsLength = checkedItems.length;
    const selectedItems = getSelectedItemText(checkedItemsLength, rowsLength);

    return (
        <div className="qc-work-queue-control-buttons__wrapper">
            <Typography
                variant="h5"
                className="control-buttons__elem control-buttons__elem_title"
            >
                QC JOBS
            </Typography>
            <div className="control-buttons__elem control-buttons__elem_selected-items">
                {selectedItems}
            </div>
            {checkedItemsLength > 0 && (
                <div className="control-buttons__elem control-buttons__elem_links">
                    {getJiraCreateLink(handleMultiItemsNewJiraIssue, isJiraCreationDisabled)}
                </div>
            )}
        </div>
    );
};

export default QCWorkQueueJobsControlButtons;
